<template>
  <header class="z-1">
    <nav class="f-nav navbar" :class="navClasses" :data-variant="variant">
      <div :class="containerClass">
        <slot name="brand"></slot>
        <slot name="center"></slot>
        <slot name="actions"></slot>
        <slot name="drawer"></slot>
      </div>
    </nav>
  </header>
</template>

<script lang="ts">
import { Options, prop, Vue } from "vue-class-component";

class Props {
  variant = prop<string>({ default: "classical" });
  theme = prop<string>({ default: "dark" });
  containerClass = prop<string>({ default: "container-fluid px-md-5" });
}

@Options({})
class AppHeader extends Vue.with(Props) {
  scrolled = false;

  get navClasses(): Record<string, boolean> {
    return {
      "navbar-expand-xxl": this.variant === "classical",
      "navbar-expand": this.variant === "empty",
      "bg-transparent": this.variant === "empty",
      "bg-secondary": this.variant === "classical" && this.theme === "light",
      "bg-primary": this.variant === "classical" && this.theme !== "light",
      "border-gradient-glow-warning-bottom": this.variant === "classical",
      "navbar-scrolled": this.variant === "classical" && this.scrolled,
    };
  }

  mounted() {
    if (this.variant === "classical") {
      window.addEventListener("scroll", this.handleScroll);
    }
  }

  beforeUnmount() {
    if (this.variant === "classical") {
      window.removeEventListener("scroll", this.handleScroll);
    }
  }

  handleScroll() {
    this.scrolled = window.scrollY > 50;
  }
}
export default AppHeader;
</script>

<style lang="scss" scoped>
@import "@/assets/sass/variables.scss";

.f-nav {
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.f-nav[data-variant="classical"] {
  min-height: 74px;
  align-items: center;

  &.navbar-scrolled {
    padding: 0.8rem 0;
  }
}

.f-nav[data-variant="empty"] {
  min-height: 132px;

  &.navbar-scrolled {
    padding: 0.8rem 0;
  }
}
</style>
